import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import useDebounce from 'modules/common/hooks/useDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import UpdateModal from '../components/UpdateModal';
import BarangayProfileContent from './BarangayProfileContent';

const form = {
  q: '',
  sort_by: 'desc',
};

function BarangayProfileContainer({
  match,
  history,
  getBarangayProfileList,
  barangayProfileList,
  isLoading,
  barangayProfileListPager,
  getOrdinanceRevision,
  ordinanceRevision
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const effectivityOptions =
    ordinanceRevision.map(data => {
      return {
        value: data.id,
        label: data.attributes.effectivity,
      };
    }) || {};

  const defaultFormValue = effectivityOptions[0];

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal 
          updateList={data.attributes} 
          id={data.id} 
          ordinanceRevisionId={_.get(defaultFormValue, 'value')} 
        />
      ),
      title: 'Update Barangay Profile',
      modalSize: 'modal-md',
    });
  };

  useEffect(() => {
    getBarangayProfileList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  useEffect(() => {
    if (debouncedSearchTerm) {
      getBarangayProfileList(debouncedSearchTerm)
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    getOrdinanceRevision();
  }, [])
  
  return (
    <Route
      path={`${match.path}/:barangayProfileId?`}
      render={({ match: { params } }) => (
        <GenericListPair
          moduleName="Barangay Profile"
          getData={getBarangayProfileList}
          setKeyword={handleOnChange}
          keyword={_.get(formData, 'q') || ''}
          keywordPlaceholder="Search..."
          pathName={`${match.path}/:barangayProfileId?`}
          listName="barangayProfile"
          label="Barangay Profile"
          renderItem={(item) => (
            <div className="p-3">{_.get(item, 'attributes.barangay_name')}</div>
          )}
          isLoading={isLoading}
          selected={params.barangayProfileId}
          data={barangayProfileList}
          dataPager={barangayProfileListPager}
          handleSelectRow={(data) => {
            history.push(`${match.url}/${_.get(data, 'id')}`);
          }}
          renderContent={() => (
            <React.Fragment>
              <Switch>
                <Route
                  path={`${match.path}/:barangayProfileId?`}
                  render={() => (
                    <BarangayProfileContent
                      handleEdit={handleEdit}
                    />
                  )}
                />
              </Switch>
              <Route
                path={`${match.path}/:barangayProfileId?`}
                render={() =>
                  !params.barangayProfileId &&
                  barangayProfileList.length > 0 ? (
                    <Redirect
                      to={`${match.url}/${_.get(
                        barangayProfileList,
                        '0.id'
                      )}`}
                    />
                  ) : null
                }
              />
            </React.Fragment>
          )}
          handleChangePage={(page) => (
            setFormData((prev) => ({ ...prev, page }))
          )}
        />
      )}
    />
  );
}

BarangayProfileContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getBarangayProfileList: PropTypes.instanceOf(Function).isRequired,
  barangayProfileList: PropTypes.instanceOf(Array).isRequired,
  barangayProfileListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getOrdinanceRevision: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevision: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  barangayProfileList: _.get(api, `${c.GET_BARANGAY_PROFILE}.list`) || [],
  barangayProfileListPager:
    _.get(api, `${c.GET_BARANGAY_PROFILE}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_BARANGAY_PROFILE) > -1,
  ordinanceRevision: _.get(api, `${c.GET_ORDINANCE_REVISION}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BarangayProfileContainer);
